/* eslint-disable react/destructuring-assignment */
import { Flex, FlexProps } from "@chakra-ui/react";

import { OFText } from "design_system/components/OFText";

import { BADGE_THEME, BadgeVariantType } from "./badge.constant";

const SIZES = {
  large: { h: "36px" },
  small: { h: "24px" }
};

type Props = FlexProps & {
  variant?: BadgeVariantType;
  size?: "large" | "small";
  children: string;
  iconProps?: { [value: string]: string };
};

const OFBadge = ({ variant = "filledBlue", size = "large", children, ...props }: Props) => {
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      borderRadius="20px"
      w="max-content"
      px="12px"
      whiteSpace="nowrap"
      {...SIZES[size]}
      {...BADGE_THEME[variant]}
      {...props}
    >
      <OFText
        flex={1}
        color="inherit"
        textAlign="center"
        textStyle={size === "large" ? "subhead1" : "labels"}
      >
        {children}
      </OFText>
    </Flex>
  );
};

export default OFBadge;
